import { render, staticRenderFns } from "./datepage.vue?vue&type=template&id=3bc0f659&scoped=true"
import script from "./datepage.vue?vue&type=script&lang=js"
export * from "./datepage.vue?vue&type=script&lang=js"
import style0 from "./datepage.vue?vue&type=style&index=0&id=3bc0f659&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0f659",
  null
  
)

export default component.exports